import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_REQUEST_EXPENSES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_REQUEST_EXPENSE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_REQUEST_EXPENSE:
      return { ...state, [action.payload.Id]: action.payload };

    default:
      return state;
  }
};
